import React, { Component } from 'react';
import SurveyRect from './Shared/SurveyRect';
import FormatText from '../Utils/TextFormatter';
import Button from './Shared/Button';
import DropdownButton from './Shared/DropdownButton';
import MultiAns from './Shared/MultiAns';
import shuffleAnswers from '../Utils/ShuffleAnswers';


export default class DropdownSelectionPage extends Component {

    state = {
        // isCurrent: false,
        // ansInx:-1,
        // qKey:"",
        // answer:"",
        // showAnswers: false,
        lists: [],
        listsSelections: {},
        isSelecting: false,
        currentListInx: "",
        showBottomFade: true,
    }

    componentDidUpdate(){
        const {lists} = this.props;
      
        //Updating lists preview during backoffice editing:
        if(this.state.lists !== lists){
            this.setState({lists:lists})
        }
    }

    componentDidMount(){
        const {readingTime, lists} = this.props;
        // console.log(`[+]\t readingTime = ${readingTime}`)
        if(readingTime === 0) {
            this.setState({showAnswers: true});
        }

        let _lists = lists;
        let _listsSelections = {};

        for(let i=0; i<_lists.length; i++){
            _listsSelections[_lists[i].key] = {key: '???', title: ''};

            if(_lists[i].randomizeOrder) {
                _lists[i].options = shuffleAnswers(_lists[i].options);
            }
        }

        // this.props.lists.forEach((l)=>{
        //     _listsSelections[l.key] = {key:'???',title:''};
        // });

        // if(randomizeOptionsOrder){_lists = shuffleAnswers(lists)}

        this.setState({lists:_lists, listsSelections: _listsSelections});
    }


    render(){
        const {style, preface, isCurrent, question, qTextSize, ansSpacing, ansTxtSize, altButtonTitle} = this.props;
        const {lists, listsSelections, isSelecting, currentListInx} = this.state;
        // const answers = JSON.parse(this.props.answers)
        // console.log(`[++]\t qKey = ${qKey} readingTime = ${readingTime}, isCurrent = ${this.state.isCurrent}, showAnswers = ${this.state.showAnswers}`)

        const buttonText = (altButtonTitle !== "" && altButtonTitle !== undefined) ? altButtonTitle : "המשך";

        const padding = 28;
        let spacing = 60; 
        if(ansSpacing === 'spacious') spacing = 80;
        if(ansSpacing === 'narrow') spacing = 40;
        
        let questionText;
        if(qTextSize === `small`){ 
            questionText = <div className="smallQuestion">{FormatText(global.isMale,question)}</div>
        }
        if(qTextSize === `medium`){ 
            questionText = <h3>{FormatText(global.isMale,question)}</h3>
        }
        if(qTextSize === `large`){ 
            questionText = <h2>{FormatText(global.isMale,question)}</h2>
        }

		return [<div key={'a1'} id="selection_interface" style={{
            position: "absolute",
            bottom:0, 
            width: "100%",
            height: global.isMobile ? window.innerHeight * 360 / window.innerWidth : "100%",
            backgroundColor: 'white',
            borderRadius: global.isMobile ? 0 : 16,
            zIndex: 999,
            display: isCurrent ? '': 'none', 
            visibility: isSelecting ? 'visible' : 'hidden',
            opacity: isSelecting ? 1 : 0,
            transition:"all 0.15s ease-out",

            }}>
                <span id="close_selection" style={{
                    position: "absolute",
                    zIndex: 10,
                    left: 20,
                    top: 16,
                    fontWeight: "bold",
                    fontSize: 20,
                    userSelect: 'none',
                    cursor: 'pointer',
                    color: global.colorTheme.main,
                }} onClick={()=>{this.setState({isSelecting:false})}}>✕</span>
               
               { lists[currentListInx] !== undefined && 
               <div id="selection_scrollview" 
                style={{
                    position: "absolute",
                    bottom:0, right:0, top:0, left: 0,
                    overflowY: 'auto'
                }}
                onScroll={(e)=>{
                    const cont = e.target;
                    const isBottom = cont.scrollHeight - cont.scrollTop <= cont.clientHeight + 60;
                    this.setState( {showBottomFade: !isBottom} );
                }}
                >
               
                <div id="options_container" style={{
                    position: "absolute",
                    right:32,top:32,
                    left:32,
                    height: spacing * (1 + lists[currentListInx].options.length )
                }}>
                        {lists[currentListInx] === undefined ? '' : lists[currentListInx].options.map((_op,i)=>{
                            return <MultiAns key={"opt_" + i} txt={_op.title} 
                                H={40} W={"100%"} B={(lists[currentListInx].options.length-i)*spacing}
                                isChoosen={false}
                                isOpenAns={_op.isOpen}
                                ansTxtSize={ansTxtSize}
                                qKey={this.props.qKey}
                                onClick={(value)=>{
                                    
                                    const option = _op;
                                    option.title = _op.isOpen ? value : _op.title;
                                    option.key = _op.isOpen ? _op.title : _op.key;

                                    const newListsSelections = listsSelections;
                                    newListsSelections[lists[currentListInx].key] = option;

                                    this.setState({isSelecting:false, listsSelections:newListsSelections})
                                }}/>
                        })}
                    </div>
                </div>
                }
                {
                    this.state.showBottomFade &&
                    <div id="bottom_fade" style={{
                        position: "absolute",
                        zIndex: 2,
                        bottom: 0, right: 0, left: 0, 
                        height: 120,
                        pointerEvents: 'none',
                        background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)'
                    }}/>
                }
            </div>,
        
            <div key={'a2'} style={style}>           
            <SurveyRect {...this.props} H={440}>
                <div  style={{
                    position: "absolute",
                    right: padding,
                    left: padding,
                    top: padding,
                    bottom: 0,
                    overflow: "scrollY",
                    textAlign: "right",
                }}>
                    {(preface !== ``) && <div className="preface">{FormatText(global.isMale,preface)}</div>}
                    {questionText}
                    <div className="separation-bar"/>
                {lists.map((_li,i)=>{
                    return <DropdownButton key={"db" + i} style={{
                            marginTop: 16,
                            marginBottom: 16,
                        }} 
                        text={_li.title + ":"} 
                        selectedValue={listsSelections[_li.key] !== undefined ? listsSelections[_li.key].title : 'none'} 
                        isActive={true} 
                        onClick={()=>{
                            this.setState({isSelecting:true, currentListInx: i});
                        }}/>
                })}
                <Button style={{
                    position:"absolute",
                    left:0,
                    bottom:padding,
                }} text={buttonText} isActive={this.validate()} onClick={() => {
                    // validate & save
                    this.SetAnswer();
                }}/>
                </div>
            </SurveyRect>
        </div>]
    }

    validate(){
        const ls = this.state.listsSelections;
        let valid = 0;
       
        for(let key in ls){
            if(ls[key].title !== "") valid++;
        }

        return valid === Object.keys(ls).length;
    }

    SetAnswer()
    {
        // console.log("this.state.listsSelections : " + JSON.stringify(this.state.listsSelections,null,2));
        
        const ls = this.state.listsSelections;

        for(let key in ls){
            let ansKey = this.props.qKey + "_" + key;
            global.setAnswer(ansKey, ls[key].key);
            // console.log(ls[key])
        }

        global.nextStage(this.props.followingScreen);
    }
}


// WEBPACK FOOTER //
// ./src/Comp/DropdownSelectionPage.js